import React from 'react';
import { motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Skills from './components/Skills';
import Projects from './components/Projects';
import StarField from './components/StarField';
import TargetCursor from './components/TargetCursor';
import ScrollFloat from './components/ScrollFloat';
import TicTacToe from './components/TicTacToe';
import './App.css';

function App() {
    return (
        <div className="App">
            <StarField />
            <TargetCursor />
            <Navbar />


            <div className="snap-container">
                <Hero />

                <section id="about" className="section snap-section">
                    <div className="container">
                        <motion.div
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: false, amount: 0.3 }}
                        >
                            <h2 className="section-title">
                                <ScrollFloat>About Me</ScrollFloat>
                            </h2>
                            <p className="section-subtitle">Design. Deploy. Scale.</p>
                        </motion.div>

                        <motion.div
                            className="about-content"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                            viewport={{ once: false, amount: 0.3 }}
                        >
                            <p>
                                I am a Cloud Engineer who designs, deploys, and operates infrastructure across
                                AWS and Microsoft Azure. I am currently completing an MSc in Cloud Computing
                                alongside full-time work in cloud operations.
                            </p>
                            <p>
                                Day to day, that means keeping production environments healthy: automating the
                                operational work, managing identity and access, patching and hardening systems,
                                and planning for the days things go wrong through monitoring and disaster recovery.
                            </p>
                            <p>
                                My approach is pragmatic. Build what is necessary, automate what is repeatable,
                                and document what matters.
                            </p>
                        </motion.div>
                    </div>
                </section>

                <Skills />

                <section id="experience" className="section snap-section experience-section">
                    <div className="container">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: false, amount: 0.3 }}
                        >
                            <h2 className="section-title">
                                <ScrollFloat>Experience</ScrollFloat>
                            </h2>
                            <p className="section-subtitle">Where I have done the work</p>
                        </motion.div>

                        <div className="timeline">
                            <motion.div
                                className="skill-timeline-item"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <div className="skill-timeline-content">
                                    <h3>Cloud Trainee Engineer</h3>
                                    <p className="company">Noventiq</p>
                                    <p className="description">
                                        Cloud infrastructure and operations across enterprise environments — managing
                                        resources, supporting deployments, and applying security best practices.
                                    </p>
                                    <ul className="highlights">
                                        <li>Cloud operations and infrastructure support</li>
                                        <li>Identity and access management</li>
                                        <li>Security patching and compliance</li>
                                        <li>Monitoring and incident response</li>
                                    </ul>
                                </div>
                            </motion.div>

                            <motion.div
                                className="skill-timeline-item"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6, delay: 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                <div className="skill-timeline-content">
                                    <h3>Cloud Engineer Intern</h3>
                                    <p className="company">Cloudstrats</p>
                                    <p className="description">
                                        Supported cloud-deployed systems inside a managed service provider, working
                                        directly on production infrastructure and reliability practices.
                                    </p>
                                    <ul className="highlights">
                                        <li>Managed and monitored cloud-hosted services</li>
                                        <li>Performed backups of large cloud databases</li>
                                        <li>Assisted with disaster recovery drills</li>
                                    </ul>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </section>

                <Projects />

                <section id="contact" className="section contact-section snap-section">
                    <div className="container">
                        <TicTacToe />

                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: false, amount: 0.3 }}
                        >
                            <h2 className="section-title">
                                <ScrollFloat>Let's Build Something</ScrollFloat>
                            </h2>
                            <p className="contact-description">
                                Interested in cloud infrastructure, systems engineering, or potential opportunities?
                                I'm always open to discussing new projects and ideas.
                            </p>
                            <motion.a
                                href="mailto:shettyani29@gmail.com"
                                className="contact-button"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                style={{ border: 'none', cursor: 'pointer', fontSize: '1.1rem', textDecoration: 'none', display: 'inline-block' }}
                            >
                                Get In Touch
                            </motion.a>

                            <div className="social-links">
                                <motion.a
                                    href="https://github.com/ANIKETSHETTY47"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    whileHover={{ y: -3 }}
                                >
                                    GitHub
                                </motion.a>
                                <motion.a
                                    href="https://www.linkedin.com/in/aniket-s-005960130/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    whileHover={{ y: -3 }}
                                >
                                    LinkedIn
                                </motion.a>
                                <motion.a
                                    href="mailto:shettyani29@gmail.com"
                                    whileHover={{ y: -3 }}
                                >
                                    Email
                                </motion.a>
                            </div>


                        </motion.div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default App;
